import React from 'react';
import CreateList from './pages/CreateList';
import Dashboard from './pages/Dashboard';
import EditList from './pages/EditList';
import ViewFolder from './pages/ViewFolder';
import Layout from './Layout';

export const PAGES: Record<string, React.ComponentType<any>> = {
  "CreateList": CreateList,
  "Dashboard": Dashboard,
  "EditList": EditList,
  "ViewFolder": ViewFolder,
};

export const pagesConfig = {
  mainPage: "Dashboard",
  Pages: PAGES,
  Layout: Layout,
};
